import { initSentry } from "./monitoring/sentry";

initSentry();
